// src/pages/Linea.jsx

import React from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import PageFooter from '../components/PageFooter';
import LineaBanner from '../components/Linea/LineaBanner';
import LineaWrapper from '../components/Linea/LineaWrapper';

import styles from './Linea.module.scss';

const Linea = () => {
  const location = useLocation();
  const navState = location.state || {};
  const initialSelectedLinea = navState.selectedLineaId;

  return (
    <>
      <Helmet>
        <title>Zoomlion Latinoamérica | Líneas</title>
        <meta
          name="description"
          content="Catálogo completo de maquinaria Zoomlion. Líderes en maquinaria para agricultura, minería, industria y construcción. Contamos con los mejores tractores, mezcladoras de concreto, bombas de concreto, excavadoras, grúas y montacargas."
        />
        <meta property="og:title" content="Zoomlion Latinoamérica | Líneas" />
        <meta
          property="og:description"
          content="Catálogo completo de maquinaria Zoomlion. Líderes en maquinaria para agricultura, minería, industria y construcción. Contamos con los mejores tractores, mezcladoras de concreto, bombas de concreto, excavadoras, grúas y montacargas."
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Zoomlion Latinoamérica | Líneas" />
        <meta
          name="twitter:description"
          content="Catálogo completo de maquinaria Zoomlion. Líderes en maquinaria para agricultura, minería, industria y construcción. Contamos con los mejores tractores, mezcladoras de concreto, bombas de concreto, excavadoras, grúas y montacargas."
        />
      </Helmet>

      <div className={styles.container}>
        <LineaBanner />
        <LineaWrapper initialSelectedLinea={initialSelectedLinea} />
        <PageFooter />
      </div>
    </>
  );
};

export default Linea;
